export enum Status {
  planned = 'planned',
  started = 'started',
  completed = 'completed',
}
